import Edit02Icon from "@/components/shared/icons/Edit02Icon";
import {
  CButton,
  CFormInput,
  CFormSelect,
  CInputGroup,
  CInputGroupText,
  CRow,
  CSmartTable,
} from "@coreui/react-pro";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import { createIndexes } from "../../../shared/utils/ultils";
import { AppDispatch } from "../../../store";
import CustomTableFooter from "../../shared/CustomTableFooter/CustomTableFooter";
import TransactionUpdate from "./TransactionUpdate";
import { getEntities } from "./transactionManagement.api";
import {
  fetching,
  resetEntity,
  setFilterState,
  transactionSelectors,
} from "./transactionManagement.reducer";
import dayjs from "dayjs";
import {
  mapResponseStatusToColorTransaction,
  mapResponseStatusTransaction,
  ResponseStatus,
} from "@/shared/enumeration/ResponseStatus";
import { ITransaction } from "@/shared/model/transaction.model";
import axios from "@/shared/config/axios-interceptor";

const columns = [
  {
    key: "id",
    label: "Mã giao dịch",
    sorter: false,
  },
  {
    key: "userId",
    label: "ID - Thành viên",
    sorter: false,
  },
  {
    key: "type",
    label: "Kiểu",
    sorter: false,
  },
  {
    key: "money",
    label: "Số tiền",
    sorter: false,
  },
  {
    key: "bank",
    label: "Ngân hàng",
    sorter: false,
    _props: { className: "text-center" },
  },
  {
    key: "status",
    label: "Trạng thái",
    sorter: false,
  },
  {
    key: "createdDate",
    label: "Thời gian",
    sorter: false,
  },
  {
    key: "actions",
    label: "Hành động",
    sorter: false,
    _props: { className: "text-center" },
  },
];

interface IIndexTransaction extends ITransaction {
  index: number;
}

const TransactionManagement = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { initialState } = useSelector(
    (state: RootState) => state.transactionReducer
  );
  const {
    filterState,
    totalItems,
    totalPages,
    updateEntitySuccess,
    deleteEntitySuccess,
    loading,
  } = initialState;
  const [updateTransaction, setUpdateTransaction] =
    useState<ITransaction | null>(null);

  const handleUpdateTransaction = (history: ITransaction) => () => {
    setUpdateTransaction(history);
  };

  const handleCancelUpdateTransaction = (update?: boolean) => {
    setUpdateTransaction(null);
  };

  const handlePaginationChange = (page: number) => {
    if (page !== 0) {
      window.scrollTo(0, 0);
      dispatch(setFilterState({ ...filterState, page: page, keyword }));
    }
  };

  const transactions = useSelector(transactionSelectors.selectAll);
  const indexedTransaction = createIndexes(transactions, filterState);

  useEffect(() => {
    if (!deleteEntitySuccess) {
      dispatch(fetching());
      dispatch(getEntities(filterState));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filterState)]);

  useEffect(() => {
    dispatch(getEntities(filterState));
  }, []);

  useEffect(() => {
    dispatch(getEntities(filterState));
    dispatch(resetEntity());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateEntitySuccess]);

  const [keyword, setKeyword] = useState<string>("");
  const [type, setType] = useState<any>("");
  const [status, setStatus] = useState<any>("");

  const onSearch = () => {
    console.log(status);
    dispatch(getEntities({ ...filterState, keyword, type, status }));
  };

  const onReset = () => {
    setKeyword("");
    setType("");
    setStatus("");
    dispatch(getEntities({ ...filterState }));
  };

  const readTransaction = async () => {
    try {
      await axios.get(`/transaction/seen`);
      dispatch(getEntities(filterState));
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <div className="tab-outlet-content">
        <div className="table-context">
          <div className="d-flex gap-2">
            <CFormInput
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="ID hoặc Tên đăng nhập"
              style={{ width: 230 }}
            />

            <CFormSelect
              value={type}
              onChange={(e) => setType(e.target.value)}
              style={{ width: 140 }}
            >
              <option value="">Tất cả kiểu</option>
              <option value={1}>Nạp</option>
              <option value={2}>Rút</option>
              <option value={3}>Gửi tiết kiệm</option>
              <option value={4}>Phát sinh lợi nhuận</option>
              <option value={5}>Thưởng</option>
            </CFormSelect>

            <CFormSelect
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              style={{ width: 180 }}
            >
              <option value="">Tất cả trạng thái</option>
              <option value={0}>Đang chờ</option>
              <option value={1}>Thành công</option>
              <option value={2}>Thất bại</option>
            </CFormSelect>

            <CButton
              style={{ height: 42, whiteSpace: "nowrap" }}
              className="ms-2 btn-custom btn-sm text-white"
              onClick={onSearch}
            >
              Tìm kiếm
            </CButton>
            <CButton
              style={{ height: 42, whiteSpace: "nowrap" }}
              className="ms-2 bg-danger btn-custom btn-sm text-white"
              onClick={onReset}
            >
              Đặt lại
            </CButton>
          </div>
        </div>

        <div className="table-content">
          <CSmartTable
            header
            loading={loading}
            columns={columns}
            items={indexedTransaction}
            clickableRows
            noItemsLabel="Không có bản ghi"
            itemsPerPage={filterState.limit}
            scopedColumns={{
              userId: ({ index, ...value }: IIndexTransaction) => {
                return (
                  <td>
                    <div className={"d-flex align-items-center flex-nowrap"}>
                      {value?.user?.id} - {value?.user?.username}
                    </div>
                  </td>
                );
              },
              type: ({ index, ...value }: IIndexTransaction) => {
                return (
                  <td>
                    {value?.type === 1 && (
                      <span className="badge bg-success">Nạp</span>
                    )}
                    {value?.type === 2 && (
                      <span className="badge bg-danger">Rút</span>
                    )}
                    {value?.type === 3 && (
                      <span className="badge bg-secondary">Gửi tiết kiệm</span>
                    )}
                    {value?.type === 4 && (
                      <span className="badge bg-info">Phát sinh lợi nhuận</span>
                    )}
                    {value?.type === 5 && (
                      <span className="badge bg-info">Thưởng</span>
                    )}
                  </td>
                );
              },
              result: ({ index, ...value }: IIndexTransaction) => <td></td>,
              status: ({ index, ...value }: IIndexTransaction) => {
                return (
                  <td>
                    <div
                      className={
                        "d-flex align-items-center flex-nowrap text-" +
                        mapResponseStatusToColorTransaction[value?.status]
                      }
                    >
                      {mapResponseStatusTransaction[value.status]}
                    </div>
                  </td>
                );
              },
              money: ({ index, ...value }: IIndexTransaction) => {
                return (
                  <td>
                    {new Intl.NumberFormat("vi-VN").format(value?.money || 0)}
                    {/* <div className={'d-flex align-items-center flex-nowrap'}>{value.isWin ? '' : '-'}{value.money}</div> */}
                  </td>
                );
              },
              bank: ({ index, ...value }: IIndexTransaction) => {
                return (
                  <td className="text-center">
                    <div
                      className={"d-flex justify-content-between flex-column"}
                    >
                      <div className="mb-2 fw-bold">
                        {value?.user?.bankName}
                      </div>
                      <div className="mb-2">{value?.user?.cardNumber}</div>
                      <div>{value?.user?.cardName}</div>
                    </div>
                  </td>
                );
              },
              createdDate: ({ index, ...value }: IIndexTransaction) => {
                return (
                  <td>
                    <div className={"d-flex align-items-center flex-nowrap"}>
                      {dayjs(value.createdDate).format("DD/MM/YYYY HH:mm:ss")}
                    </div>
                  </td>
                );
              },
              actions: ({ index, ...value }: IIndexTransaction) => {
                return (
                  <td>
                    <CInputGroup
                      onClick={readTransaction}
                      className="custom-input-group-action justify-content-center"
                    >
                      {value?.status != 1 ? (
                        <CInputGroupText
                          onClick={handleUpdateTransaction(value)}
                          style={{
                            color: value?.isSeen ? "red" : "",
                            borderColor: value?.isSeen ? "red" : "",
                          }}
                        >
                          <Edit02Icon />
                        </CInputGroupText>
                      ) : (
                        <span className="badge bg-success">Đã duyệt</span>
                      )}
                    </CInputGroup>
                  </td>
                );
              },
            }}
            tableProps={{
              hover: true,
              align: "middle",
              responsive: "lg",
              className: "custom-table",
            }}
            tableHeadProps={{
              className: "table-head",
            }}
            tableBodyProps={{
              className: "table-body",
            }}
          />
        </div>
        {updateTransaction ? (
          <TransactionUpdate
            visible={Boolean(updateTransaction)}
            transactionObj={updateTransaction}
            setVisible={handleCancelUpdateTransaction}
          />
        ) : (
          ""
        )}
        <CRow>
          <CustomTableFooter
            totalItems={totalItems}
            hideSideChosen
            totalPages={totalPages}
            filterState={filterState}
            setFilterState={(filter) =>
              dispatch(setFilterState({ ...filter, type: 2 }))
            }
            handlePaginationChange={handlePaginationChange}
          />
        </CRow>
      </div>
    </>
  );
};

export default TransactionManagement;
